
const IfComp = ({cond, children}) => {
    if (cond) {
        return children;
    } else {
        return null;
    }
}

export default IfComp;
